import { useEffect } from "react";
import { atom, useRecoilState } from "recoil";
import { useApi } from "./useApi";

interface gradeType {
  value: string;
  label: string;
}

export const gradeListState = atom<gradeType[]>({
  key: "gradeListState",
  default: [
    {
      value: "",
      label: "",
    },
  ],
});

export default function useGradeList() {
  const [gradeOption, setGradeOption] = useRecoilState(gradeListState);

  const { response: listResponse } = useApi({
    method: "get",
    url: `auth/list`,
  });

  useEffect(() => {
    if (listResponse?.status === 200) {
      const list = [];

      for (let i = 0; i < listResponse?.data?.length; i++) {
        const e = listResponse?.data[i];

        list.push({ value: e?.id, label: e?.name });
      }

      setGradeOption(list);
    }
  }, [listResponse, setGradeOption]);

  return gradeOption;
}
